/**
 * Billing API Service
 *
 * API methods for billing and quota operations.
 */

import apiClient from './client';
import type { ApiSuccessResponse } from '../types/api.types';
import type { BillingQuotaResponse } from '../features/billing/types/billing.types';

// ============================================================================
// BILLING SERVICE
// ============================================================================

export const billingService = {
  /**
   * Get billing quotas for a tenant
   * Returns plan, limits, features, usage, and quota metrics
   */
  getQuotas: async (tenantId: string): Promise<BillingQuotaResponse> => {
    const response = await apiClient.get<ApiSuccessResponse<BillingQuotaResponse>>(
      `/tenants/${tenantId}/billing/quotas`
    );
    return response.data.data;
  },
};

export default billingService;
